<template>
  <div>
    <div class="countdown" :style="{ opacity: hideCountdown ? '0' : '1' }">
      <div class="container">
        {{ __("Your reservation will expire in") }}:
        <strong
          >{{ minutes | two_digits }} {{ __("Minutes") }}
          {{ seconds | two_digits }} {{ __("Seconds") }}</strong
        >
      </div>
    </div>
    <countdown-continue-modal
      :index="0"
      :seconds="this.seconds"
    ></countdown-continue-modal>
  </div>
</template>
<script>
import moment from "moment-timezone";

export default {
  mounted() {
    this.countDownInterval = window.setInterval(() => {
      this.elapsedSeconds++;

      this.now =
        Math.trunc(moment(this.current).tz(this.timezone).valueOf() / 1000) +
        this.elapsedSeconds;

      if (this.minutes == 0 && this.seconds == 30) {
        this.showContinueModal();
      }

      if (this.minutes <= 0 && this.seconds <= 0) {
        clearInterval(this.countDownInterval);
        if (!this.$root.checkout.paymentProcessing) {
          window.location.reload();
        }
      }
    }, 1000);
  },

  props: {
    date: {
      type: String,
    },
    timezone: {
      type: String,
    },
    current: {
      type: String,
    },
  },
  data() {
    return {
      now: Math.trunc(moment(this.current).tz(this.timezone).valueOf() / 1000),
      to: Math.trunc(moment(this.date).tz(this.timezone).valueOf() / 1000),
      elapsedSeconds: 0,
      countDownInterval: null,
    };
  },

  computed: {
    hideCountdown() {
      // hide the countdown if the payment is processing and the timer has run out
      return (
        this.checkoutpaymentProcessing && this.seconds <= 0 && this.minutes <= 0
      );
    },
    checkoutpaymentProcessing() {
      return this.$root.checkout.paymentProcessing;
    },
    seconds() {
      return (this.to - this.now) % 60;
    },

    minutes() {
      return Math.trunc((this.to - this.now) / 60) % 60;
    },

    hours() {
      return Math.trunc((this.to - this.now) / 60 / 60) % 24;
    },

    days() {
      return Math.trunc((this.to - this.now) / 60 / 60 / 24);
    },
  },
  methods: {
    showContinueModal() {
      if (!document.getElementsByClassName("countdown-continue-modal")[0]) {
        this.$modal.show("countdown-continue-modal-0");
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// resources/js/components/Countdown.vue